module.exports = __webpack_public_path__ + "img/aya shameimaru flower_sc2.7a629ea8.png";